<template>
  <div id="app">
    <page-header></page-header>
    <div id="content">
      <transition name="slide-fade">
        <router-view />
      </transition>
      <!-- 底部 公司信息 -->
      <page-footer></page-footer>
      <!-- 回到顶部btn -->
      <to-top></to-top>
    </div>
  </div>
</template>
<script>
import pageHeader from '@/components/header.vue';
import pageFooter from "@/components/footer.vue";
import toTop from '@/components/totop.vue';
import ofun from './assets/js/index';


export default {
  data () {
    return {}
  },
  components: {
    pageHeader,
    pageFooter,
    toTop
  },
  mounted () {
    ofun();
  }
}
</script>

<style scoped lang="scss">
#app {
  height: 100%;
}

// 动画
.slide-fade {
  position: absolute;
  left: 0;
  right: 0;
}

.slide-fade-enter-active {
  transition: all 1.2s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s linear;
  // cubic-bezier(2.0, 0.5, 0.8, 1.0);  // 三次贝塞尔，用四个点（p0,p1,p2,p3）描绘一条曲线 
}

.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  right: 0;
  // transform: translateX(30px);
  opacity: 0;
}
</style>
